import styled from 'styled-components'

export default styled.span`
    display: inline-block;
    margin-left: auto;

    &:before {
        display: inline-block;
        margin: 0 5px 0 0;
        vertical-align: middle;
    }
`
